import CustomImageComponent from '@/components/shared/custom/custom-image';
import { getCountryImage } from '@/helpers/images-helper';
import { Box } from '@mui/material';
import { useMemo } from 'react';

const CountryConvocado = ({ country, isConvocado, ...props }) => {
    if (!isConvocado) return null;

    const countryImage = useMemo(() => {
        return getCountryImage(country, 15);
    }, [country]);

    return (
        <Box {...props}>
            <CustomImageComponent src={countryImage} alt={country} width={15} height={15} />
        </Box>
    );
};

export default CountryConvocado;
